import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f38dc1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-search flex-col" }
const _hoisted_2 = { style: {"margin-bottom":"10px"} }

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed } from 'vue'
import { cloneDeep } from 'lodash'
import { clearForm, setDefaultForm } from '@/util/common'
import dblclick from '@/components/BatchSearch/index'
import { apiShopName } from '@/common/const'
import { getCustomerShopPlatform } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: ['form', 'states', 'isShopify'],
  emits: ['update:form'],
  setup(__props, { emit: emits }) {

const props = __props



const searchDate = computed({
  get: () => [_form.value.shopOrderStartTime, _form.value.shopOrderEndTime],
  set: (newVal) => {
    [_form.value.shopOrderStartTime, _form.value.shopOrderEndTime] = newVal ?? []
  }
})

const defaultForm = {
  shopOrderId: '',
  shopOrderStartTime: '',
  shopOrderEndTime: ''
}

const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)

const _form = ref(getForm(props.form))

watch(() => props.form, (newValue) => {
  _form.value = getForm(newValue)
})

const submit = () => {
  emits('update:form', cloneDeep(toRaw(_form.value)))
}

const resetForm = () => {
  clearForm(_form.value)
  emits('update:form', cloneDeep(toRaw(_form.value)))
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      inline: true,
      model: _form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(t)('店铺订单号'),
          prop: "shopOrderId"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.shopOrderNo,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.shopOrderNo) = $event)),
              onDblclick: _cache[1] || (_cache[1] = ($event: any) => {_form.value.shopOrderNo='';_unref(dblclick)('shopOrderNos')}),
              placeholder: _unref(t)('双击批量搜索'),
              style: {"width":"230px"}
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('订单时间')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: _unref(searchDate),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchDate) ? (searchDate).value = $event : null)),
              type: "daterange",
              "range-separator": "-",
              "start-placeholder": _unref(t)('开始时间'),
              "end-placeholder": _unref(t)('结束时间'),
              format: "YYYY-MM-DD",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        (__props.isShopify)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _unref(t)('订单') + `(${_unref(getCustomerShopPlatform)()})`,
              prop: "orderName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _form.value.orderName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_form.value.orderName) = $event)),
                  onDblclick: _cache[4] || (_cache[4] = ($event: any) => {_form.value.orderName='';_unref(dblclick)('orderNames')}),
                  placeholder: _unref(t)('双击批量搜索'),
                  style: {"width":"230px"}
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('收件人'),
          prop: "orderName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.receiveName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_form.value.receiveName) = $event)),
              style: {"width":"190px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "warning",
              onClick: submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "text",
              onClick: resetForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('重置')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})